import { IPromotion } from '../types';

export interface IPromoViewEventSetup {
  promotions: IPromotion[];
}

export interface IPromoViewGtmEvent {
  ecommerce: {
    promoView: {
      promotions: IPromotion[];
    };
  };
}

export const promoView = (eventSetup: IPromoViewEventSetup) => {
  const { dataLayer } = window;

  if (!dataLayer) {
    return;
  }

  const { promotions } = eventSetup;

  dataLayer.push({ ecommerce: null });

  const newData: IPromoViewGtmEvent = {
    ecommerce: {
      promoView: {
        promotions,
      },
    },
  };

  dataLayer.push(newData);
};
